"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationLogo = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var logo_kincentric_mobile_png_1 = __importDefault(require("../../assets/images/logo-kincentric-mobile.png"));
var logo_kincentric_png_1 = __importDefault(require("../../assets/images/logo-kincentric.png"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var OrgLogoLink = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-left: 15px;\n\twidth: 360px;\n\theight: 45px;\n\tdisplay: ", ";\n\talign-items: ", ";\n\tjustify-content: ", ";\n\tz-index: 1020;\n\tposition: absolute;\n\ttransition: none;\n\tbackground: url(", ");\n\tbackground-size: 360px 45px;\n\tbackground-repeat: no-repeat;\n\ttop: 0;\n\t@media (max-width: 768px) and (min-width: 0) {\n\t\twidth: 45px;\n\t\tbackground: url(", ");\n\t\tbackground-size: 45px 45px;\n\t}\n"], ["\n\tmargin-left: 15px;\n\twidth: 360px;\n\theight: 45px;\n\tdisplay: ", ";\n\talign-items: ", ";\n\tjustify-content: ", ";\n\tz-index: 1020;\n\tposition: absolute;\n\ttransition: none;\n\tbackground: url(", ");\n\tbackground-size: 360px 45px;\n\tbackground-repeat: no-repeat;\n\ttop: 0;\n\t@media (max-width: 768px) and (min-width: 0) {\n\t\twidth: 45px;\n\t\tbackground: url(", ");\n\t\tbackground-size: 45px 45px;\n\t}\n"])), globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, globalVars_module_scss_1.default.alignCenter, logo_kincentric_png_1.default, logo_kincentric_mobile_png_1.default);
OrgLogoLink.displayName = 'OrgLogoLink';
var OrganizationLogo = /** @class */ (function (_super) {
    __extends(OrganizationLogo, _super);
    function OrganizationLogo(props) {
        var _this = _super.call(this, props) || this;
        _this.targetLogo = logo_kincentric_png_1.default;
        return _this;
    }
    OrganizationLogo.prototype.render = function () {
        return React.createElement(OrgLogoLink, { className: 'tws-orglogo-link', href: this.props.href ? this.props.href : '#' });
    };
    return OrganizationLogo;
}(React.Component));
exports.OrganizationLogo = OrganizationLogo;
var templateObject_1;
